import { Reveal } from '@/components/Reveal';
import SectionIndex, { IndexEntry } from '@/components/SectionIndex';
import Typography from '@/components/ui/typography';
import Band from '@/Layouts/Band';
import SectionLayout from '@/Layouts/SectionLayout';

import { specialEvents } from './SpecialEvents/Index';

const about: IndexEntry[] = [
  {
    title: 'About Academy',
    summary:
      'Genuinely enthralled to unveil a profoundly inspiring and exquisitely beautiful tale of success.',
    link: 'academy',
  },
  {
    title: 'About CEO & Founder',
    summary:
      'The Journey of Rtn Thamizhachi Priya Govindaraj, From a Zero-Investment Beginning to a Trailblazing Entrepreneur with Over 50 Awards',
    link: 'founder',
  },
  {
    title: 'Awards & Accolades',
    summary:
      'Rtn Thamizhachi Priya Govindaraj is a remarkable woman, celebrated with over 100 awards as both a successful Female Entrepreneur and an Inspirational Motivational Speaker.',
    link: 'awards-and-accolades',
  },
  {
    title: 'Recognitions',
    summary:
      'Amidst the clamor of acclaim from esteemed newspapers and magazines, resonant echoes on influential radio waves, and the glow of admiration on popular YouTube screens, stands the illustrious Samuthrika Academy.',
    link: 'recognitions',
  },
];

const Index = () => {
  return (
    <>
      <Band tone="raised" pattern="lattice">
        <SectionLayout space="lg">
          <Reveal className="flex max-w-2xl flex-col gap-4">
            <Typography.Eyebrow>Trichy &middot; since 2011</Typography.Eyebrow>
            <Typography.Display1 className="text-4xl md:text-5xl lg:text-6xl">
              About Samuthrika
            </Typography.Display1>
            <Typography.Body className="text-muted-foreground">
              An academy that started on an open terrace and now runs across
              Tamil Nadu — and the founder who built it.
            </Typography.Body>
          </Reveal>

          <SectionIndex entries={about} />
        </SectionLayout>
      </Band>

      {/*
        The Special Events entries are listed here rather than by rendering
        SpecialEvents/Index inside this page, which was the previous approach —
        it brought that page's own heading along with it and gave this one two
        competing page titles.
      */}
      <Band tone="surface" pattern="stitch" seam>
        <SectionLayout space="lg">
          <Reveal className="flex max-w-2xl flex-col gap-4">
            <Typography.Eyebrow>Beyond the classroom</Typography.Eyebrow>
            <Typography.Display2 className="text-2xl md:text-3xl lg:text-4xl">
              Special events
            </Typography.Display2>
          </Reveal>

          <SectionIndex entries={specialEvents} />
        </SectionLayout>
      </Band>
    </>
  );
};

export default Index;
